/** COMMERCE-175A — customer visual fiscal receipt card (dark surface + light QR island). */
import { useMemo } from "react";
import { fiscalQrSvg } from "./fiscal-qr-svg.js";

export function FiscalReceiptCardV2({
  publicOrderNumber,
  amountUah,
  issuedAt,
  receiptUrl,
  fiscalNumber,
  lang,
}: {
  publicOrderNumber: string;
  amountUah?: number | null;
  issuedAt?: string | null;
  receiptUrl: string;
  fiscalNumber?: string | null;
  lang: "uk" | "en";
}) {
  const en = lang === "en";
  const sum =
    amountUah != null && Number.isFinite(amountUah)
      ? `${amountUah.toFixed(2).replace(".", ",")} грн`
      : "—";
  const qr = useMemo(() => fiscalQrSvg(receiptUrl), [receiptUrl]);
  return (
    <div
      className="sv2-fiscal-receipt-card"
      data-testid="sv2-fiscal-receipt-card"
      data-theme="dark"
      data-qr-real={qr ? "1" : "0"}
    >
      <div className="sv2-fiscal-receipt-accent" aria-hidden="true" />
      <div className="sv2-fiscal-receipt-qr-island" aria-hidden="true">
        {qr ? (
          <img
            className="sv2-fiscal-receipt-qr"
            alt=""
            width={96}
            height={96}
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(qr)}`}
          />
        ) : null}
      </div>
      <div className="sv2-fiscal-receipt-meta">
        <div className="sv2-fiscal-receipt-title">✅ {en ? "Fiscal receipt" : "Фіскальний чек"}</div>
        <div className="sv2-fiscal-receipt-order">{publicOrderNumber}</div>
        {issuedAt ? <div className="sv2-fiscal-receipt-sub">{issuedAt}</div> : null}
        <div className="sv2-fiscal-receipt-amount">{sum}</div>
        {fiscalNumber ? <div className="sv2-fiscal-receipt-sub">FN: {fiscalNumber}</div> : null}
        <a
          className="sv2-fiscal-receipt-open"
          href={receiptUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="sv2-receipt-open-btn"
        >
          {en ? "View original" : "Переглянути оригінал"}
        </a>
      </div>
    </div>
  );
}
